(function () {
  var HEADER_OFFSET = 120;

  function scrollToTarget(id) {
    var target = document.getElementById(id);
    if (!target) return;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var top = target.getBoundingClientRect().top + window.scrollY - HEADER_OFFSET;
    window.scrollTo({ top: top, behavior: reduceMotion ? 'auto' : 'smooth' });
  }

  function initAnchors(root) {
    root.querySelectorAll('[data-fw-jdass-scroll]').forEach(function (link) {
      if (link.dataset.fwJdassBound === 'true') return;
      link.dataset.fwJdassBound = 'true';
      link.addEventListener('click', function (event) {
        var id = link.getAttribute('data-fw-jdass-scroll');
        if (!id) return;
        event.preventDefault();
        scrollToTarget(id);
      });
    });
  }

  function measurePartnersMarquee(track) {
    var firstSet = track.querySelector('.fw-jdass__partners-set');
    if (!firstSet) return;
    var shift = firstSet.getBoundingClientRect().width;
    if (shift > 0) {
      track.style.setProperty('--fw-partners-shift', shift + 'px');
    }
  }

  function initPartnersMarquee(root) {
    root.querySelectorAll('[data-fw-jdass-partners-track]').forEach(function (track) {
      if (track.dataset.fwJdassMarqueeBound === 'true') return;
      track.dataset.fwJdassMarqueeBound = 'true';

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        track.style.animation = 'none';
        return;
      }

      var remeasure = function () {
        measurePartnersMarquee(track);
      };

      remeasure();

      track.querySelectorAll('img').forEach(function (img) {
        if (!img.complete) {
          img.addEventListener('load', remeasure, { once: true });
        }
      });

      if (typeof ResizeObserver !== 'undefined') {
        var observer = new ResizeObserver(remeasure);
        track.querySelectorAll('.fw-jdass__partners-set').forEach(function (set) {
          observer.observe(set);
        });
      } else {
        window.addEventListener('resize', remeasure);
      }

      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(remeasure);
      }
    });
  }

  function initTradeForm(root) {
    var form = root.querySelector('[data-fw-jdass-trade-form]');
    if (!form || form.dataset.fwJdassFormBound === 'true') return;
    form.dataset.fwJdassFormBound = 'true';

    form.addEventListener('submit', function () {
      var btn = form.querySelector('[type="submit"]');
      if (btn) {
        btn.disabled = true;
        btn.setAttribute('aria-busy', 'true');
      }
    });
  }

  function boot() {
    document.querySelectorAll('.fw-jdass').forEach(function (section) {
      initAnchors(section);
      initPartnersMarquee(section);
      initTradeForm(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target;
    if (!(section instanceof Element)) return;
    section.querySelectorAll('.fw-jdass').forEach(function (root) {
      initAnchors(root);
      initPartnersMarquee(root);
      initTradeForm(root);
    });
  });
})();
